import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Typography,
	Grid,
	Button,
	Tooltip,
	MenuItem,
	Checkbox,
	Menu,
} from '@material-ui/core';
import {
	AssignmentIndOutlined as RoleIcon,
	Edit as EditIcon,
	MoreVert as MoreIcon,
	RemoveCircle as RemoveIcon,
	AddCircle as AddIcon,
	Close as CloseIcon,
	RemoveRedEye as ViewIcon,
} from '@material-ui/icons';
import {
	MyPATExpansionPanel,
	MyPATSelect,
	MyPATDialog,
	MyPATIconButton
} from '../../common';

import { UserRoleList, deleteRole, getRolesCount } from '../actions/userRoleAction';
import { usersList } from '../actions/usersActions';
import { UserRoleBody } from '../types/UserRolesBody';
import CreateRoleDialog from '../components/CreateRoleDialog'
import ACLService from '../../acl/services/aclService'


const styles = (theme: Theme) => createStyles({
	textRight: {
		textAlign: 'right',
	},
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	mb1x5x: {
		marginBottom: theme.spacing.unit * 1.5,
	},
	fwNormal: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	textCapitalize: {
		textTransform: 'capitalize',
	},
	addComma: {
		marginRight: theme.spacing.unit / 4,
		fontWeight: theme.typography.fontWeightRegular,
		textTransform: 'capitalize',
		'&:after': {
			content: "','",
		},
		'&:last-child': {
			marginRight: 0,
			'&:after': {
				content: "''",
			}
		}
	},

	roleIcon: {
		borderRadius: '50%',
		color: theme.palette.primary.main,
		border: `1px solid ${theme.palette.primary.main}`,
		padding: theme.spacing.unit * 1.5,
		width: theme.spacing.unit * 8.5,
		height: theme.spacing.unit * 8.5,
	},

	actionsPermission: {
		cursor: "pointer",
		fontSize: "0.68em",
		paddingLeft: theme.spacing.unit,
		color: theme.palette.primary.main
	},
	checkBoxFeature: {
		padding: "0px",
	},
	checkBoxText: {
		fontSize: "0.68em",
	},
	selectBoxGrid: {
		'& > div': {
			width: '100%',
			'& > div > div > div': {
				fontSize: '0.8rem',
			}
		}
	},

	userRoleGridBox: {
		paddingTop: theme.spacing.unit,
		paddingBottom: theme.spacing.unit,
	},
	descriptionBox: {
		paddingLeft: `${theme.spacing.unit}px !important`,
	},
	iconBox: {
		borderRight: `1px solid ${theme.palette.grey[400]}`,
		paddingRight: `${theme.spacing.unit * 2.5}px !important`,
	},

	moreMenu: {
		'& li': {
			height: theme.spacing.unit * 2,
			color: theme.palette.text.secondary,
			fontSize: '0.8rem',
			paddingTop: theme.spacing.unit,
			paddingBottom: theme.spacing.unit,
			'& > svg': {
				marginRight: theme.spacing.unit,
				fontSize: '1rem',
			}
		}
	},
	featureLabel: {
		textAlign: 'right',
	},
});


interface UserRoleContentProps extends WithStyles<typeof styles> {
	classes: any,
	getRolesCount: () => void,
	UserRoleList: () => void,
	userRoles: UserRoleBody[],
	rolesEnumType: Function,
	enumRoles: any,
	usersList: Function,

}

interface UserRoleContentState {
	dialogOpen: boolean,
	updateRole: UserRoleBody,
	isDeleteDialogOpen: boolean,
	deleteId: string,
	anchorEl: any,
	openMenu: string,
}

class UserRoleContent extends Component<UserRoleContentProps, UserRoleContentState>{
	constructor(props: UserRoleContentProps) {
		super(props);

		this.state = {
			dialogOpen: false,
			updateRole: {},
			isDeleteDialogOpen: false,
			deleteId: '',
			anchorEl: null,
			openMenu: '',
		};

	}


	handleMoreMenuOpen = (evt: any, target: string) => {
		evt.stopPropagation();
		this.setState({ anchorEl: evt.currentTarget, openMenu: target });
	};

	handleMoreMenuClose = (evt: any) => {
		evt.stopPropagation();
		this.setState({ anchorEl: null, openMenu: '' })
	};

	editPermission(id: string, e: any) {
		e.stopPropagation();
		let { userRoles } = this.props;
		let { dialogOpen, updateRole } = this.state;
		let a = _.filter(userRoles, ['_id', id]);
		if (a && a.length > 0) {
			dialogOpen = true;
			updateRole = a[0];
			this.setState({ updateRole, dialogOpen })
		}
	}

	deletePermission(id: string, e: any) {
		e.stopPropagation();
		this.setState({ isDeleteDialogOpen: true, deleteId: id });
	}

	handleConfirmDelete = (evt: any) => {
		let { deleteId } = this.state;
		let { userRoles } = this.props;
		if (deleteId) {
			let userD: any = _.find(userRoles, ['_id', deleteId]);
			deleteRole(userD._id, userD.role)
				.then((res) => {
					this.props.UserRoleList();
					this.props.getRolesCount();
					this.props.usersList();
					this.setState({ isDeleteDialogOpen: false, deleteId: "" });
				})
		}

	}

	dialogCloseHandler() {
		this.setState({ dialogOpen: false, deleteId: "", isDeleteDialogOpen: false });
	}


	render() {
		const { classes, userRoles, enumRoles } = this.props;
		const { dialogOpen, updateRole, isDeleteDialogOpen, anchorEl, openMenu } = this.state;
		

		return (
			<>
				{_.map(userRoles, (userRole, i) => (
					<MyPATExpansionPanel
					    key={`${userRole._id}-${i}`}
						panelProps={{ className: classes.mb1x5x }}
						defaultExpanded={false}
						variant="white"
						customCollapseTitle={
							<Grid container alignItems="center" justify="space-between" spacing={8} className={classes.userRoleGridBox}>
								<Grid item xs="auto" className={classes.iconBox}>
									<RoleIcon className={classes.roleIcon} style={{ color: userRole.groupColor, borderColor: userRole.groupColor }} />
								</Grid>
								<Grid item xs className={classes.descriptionBox}>
									<Typography variant="h6">
										<strong className={classes.textCapitalize}>{userRole.role}</strong>
									</Typography>
									<Typography variant="body2" className={classes.textCapitalize}>
										{userRole.description}
									</Typography>
									{(!_.isUndefined(userRole.featureLevelPermissions) && userRole.featureLevelPermissions.length > 0) && (
										<Typography variant="body2" className={classes.fwNormal}>
											Has access to
											{_.map(userRole.featureLevelPermissions, (featurePermission, j) => (

												!_.isUndefined(featurePermission.accessAllowed) && !featurePermission.accessAllowed.includes('NONE') && (
													<Tooltip
														key={j}
														placement="right-start"
														title={featurePermission.accessAllowed.join(', ')}
													>
														<span className={classes.addComma}> {_.toLower(featurePermission.featureType)}</span>
													</Tooltip>)

											))}
										</Typography>
									)}
								</Grid>
								{/* {
									(ACLService.hasAccessTo(['USER'], ['EDITROLES']) || ACLService.hasAccessTo(['USER'], ['DELETEROLES'])) && <Grid item xs="auto">
										<MyPATIconButton onClick={(e: any) => { this.handleMoreMenuOpen(e, `menu-${userRole._id}`) }}>
											<MoreIcon />
										</MyPATIconButton>
										<Menu
											id={`menu-${userRole._id}`}
											anchorEl={anchorEl}
											open={_.isEqual(`menu-${userRole._id}`, openMenu) ? true : false}
											onClose={(evt: any) => { this.handleMoreMenuClose(evt) }}
											className={classes.moreMenu}
										>
											{
												ACLService.hasAccessTo(['USER'], ['EDITROLES']) &&
												<MenuItem onClick={this.editPermission.bind(this, !_.isUndefined(userRole._id) ? userRole._id : "")}>
													<EditIcon /> Edit
                     </MenuItem>
											}
											{
												ACLService.hasAccessTo(['USER'], ['DELETEROLES']) &&
												<MenuItem onClick={this.deletePermission.bind(this, !_.isUndefined(userRole._id) ? userRole._id : "")}>
													<CloseIcon /> Delete
                     </MenuItem>
											}
										</Menu>
									</Grid>
								} */}
							</Grid>
						}
					>
						<Grid container alignItems="center" spacing={16} justify="center">
							<Grid item xs={12}>
								<Typography variant="h6" className={classes.fwNormal}>Permissions</Typography>
							</Grid>
							<Grid item sm={10}>
								<Grid container alignItems="center" justify="space-between" spacing={16} className={classes.mb1x}>
									{_.map(userRole.featureLevelPermissions, (featurePermission:any, i) => (
										<Grid key={`${featurePermission.featureType}_${i}`} item sm={5}>
											<Grid container alignItems="center" spacing={8}>
												<Grid item xs={4}>
													<Typography variant="body1" className={classes.featureLabel}>
														{/* {!_.isUndefined(enumRoles.featureName) ? `${enumRoles.featureName[i]}:` : ''} */}
														{!_.isEmpty(enumRoles.featureName) && !_.isUndefined(enumRoles.featureName[featurePermission.featureType]) ? `${enumRoles.featureName[featurePermission.featureType]}:` : ''}
													</Typography>
												</Grid>
												<Grid item xs={8} className={classes.selectBoxGrid}>
													<MyPATSelect
														inputId={featurePermission.featureType}
														value={featurePermission.accessAllowed.join(",")}
														name={featurePermission.featureType}
													>


														{_.map(enumRoles.validAccessTypes[featurePermission.featureType], (validAccessType, i) => (
															<option key={`role_options_${i}`} value={validAccessType.split(':')[1]} >{validAccessType.split(':')[0]}</option>
														))}
													</MyPATSelect>
												</Grid>
											</Grid>
										</Grid>
									))}
								</Grid>
							</Grid>
						</Grid>
					</MyPATExpansionPanel>
				))}

				<CreateRoleDialog
					updateRole={updateRole}
					dialogOpen={dialogOpen}
					dialogCloseHandler={this.dialogCloseHandler.bind(this)}
					enumRoles={enumRoles} />

				<MyPATDialog
					dialogOpen={isDeleteDialogOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
					customDialogActions={
						<>
							<Button color="primary"
								onClick={this.handleConfirmDelete.bind(this)}
							>
								Delete
							</Button>
							<Button
								variant="contained" color="primary"
								onClick={this.dialogCloseHandler.bind(this)}
							>
								Cancel
                </Button>
						</>
					}
				>
					<Typography variant="body1">
						<strong>Deleting the role will cause in content access loss for the existing users associated with this role. Do you want to continue?</strong>
					</Typography>
				</MyPATDialog>
			</>
		)
	}
}

const mapStateToProps = (state: any) => ({
	userRoles: _.get(state, 'userManagement.userRoleList.list', []),
	enumRoles: _.get(state, 'userManagement.userRoleList.enumList', [])
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		UserRoleList,
		getRolesCount,
		usersList
	},
	dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserRoleContent));